import { Component, OnInit } from '@angular/core';
import {LoginComponent} from "@spartacus/user/account/components";
import {ICON_TYPE} from "@spartacus/storefront";
import { AuthService, TranslationService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'cx-login',
  templateUrl: './gonvarri-login.component.html',
  styleUrl: './gonvarri-login.component.scss',
  standalone: false
})
export class GonvarriLoginComponent extends LoginComponent implements OnInit{

  constructor(
    auth: AuthService, userAccount: UserAccountFacade, translation: TranslationService) {
    super(auth, userAccount, translation);
  }

  protected readonly ICON_TYPE = ICON_TYPE;
  protected isCompanySubMenuOpen: boolean = false;
  protected isAccountSubMenuOpen: boolean = false;
  protected firstClick: boolean = true;

  protected changeCompanySubMenu(): void {
    this.isCompanySubMenuOpen = !this.isCompanySubMenuOpen;
  }

  protected changeAccountSubMenu(): void {
    if(this.firstClick) {
      this.firstClick = false;
    }else {
      this.isAccountSubMenuOpen = !this.isAccountSubMenuOpen;
    }
  }

  protected hideCompanySubMenu(): void {
    this.isCompanySubMenuOpen = false;
  }

  isAdmin$(): Observable<boolean> {
    return this.user$.pipe(
      map(user =>
        (user?.roles || []).some(role => role.toLowerCase() === 'b2badmingroup')
      )
    );
  }

}
